/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresentUserRequest
 */
export interface PresentUserRequest {
    /**
     * 
     * @type {string}
     * @memberof PresentUserRequest
     */
    userId: string;
}

/**
 * Check if a given object implements the PresentUserRequest interface.
 */
export function instanceOfPresentUserRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userId" in value;

    return isInstance;
}

export function PresentUserRequestFromJSON(json: any): PresentUserRequest {
    return PresentUserRequestFromJSONTyped(json, false);
}

export function PresentUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresentUserRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['userId'],
    };
}

export function PresentUserRequestToJSON(value?: PresentUserRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
    };
}

